<!-- A drop down menu item that acts like an anchor (a) tag that navigates to the specified URL -->
<script lang="ts" setup>
    import DropDownItem from "./DropDownItem"

    const props = defineProps<{href: string, target: string, data?:any}>();

    const emit = defineEmits(["click"]);

    const onClick = () => {
        emit("click", props.data); 
    }
</script>

<template>
    <DropDownItem :usePointerStyle="true">
        <a class="dropdown-item" :href="href" :target="target" @click="onClick">
            <slot class="color:red">
                Missing DropDownButtonItem slot content
            </slot>
        </a>
    </DropDownItem>
</template>